module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/careers-production-main-2a4ee4b00e7abd1fb5426c57838a5e36.jpg";